/** Policy password lato frontend (il backend resta permissivo di proposito:
 * la validazione della robustezza vive solo qui, con checklist visiva). */

export interface PasswordRequirement {
  id: string;
  label: string;
  test: (password: string) => boolean;
}

export const PASSWORD_REQUIREMENTS: PasswordRequirement[] = [
  {
    id: "length",
    label: "Almeno 10 caratteri",
    test: (password) => password.length >= 10,
  },
  {
    id: "uppercase",
    label: "Almeno una lettera maiuscola",
    test: (password) => /[A-Z]/.test(password),
  },
  {
    id: "lowercase",
    label: "Almeno una lettera minuscola",
    test: (password) => /[a-z]/.test(password),
  },
  {
    id: "number",
    label: "Almeno un numero",
    test: (password) => /[0-9]/.test(password),
  },
  {
    id: "special",
    label: "Almeno un carattere speciale",
    test: (password) => /[^A-Za-z0-9]/.test(password),
  },
];

export function validatePassword(password: string): { valid: boolean; missing: PasswordRequirement[] } {
  const missing = PASSWORD_REQUIREMENTS.filter((req) => !req.test(password));
  return { valid: missing.length === 0, missing };
}

export function describeMissingRequirements(password: string): string {
  const { missing } = validatePassword(password);
  if (missing.length === 0) return "";
  return `La password non rispetta i seguenti requisiti: ${missing.map((r) => r.label.toLowerCase()).join(", ")}.`;
}
